import { Grid, List, ListItem } from '@mui/material';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';

import { useMeta } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { ListItemButton, Wrapper, ListItemText } from './styles';

export const Footer = () => {
  const { t } = useTranslation(TranslationNamespace.Common);

  const { telegramSupportBotUrl } = useMeta();

  const links: { title: string; link: string }[] = [
    ...(telegramSupportBotUrl
      ? [
          {
            title: 'Telegram',
            link: telegramSupportBotUrl,
          },
        ]
      : []),
  ];

  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          sx={{ display: { xs: 'none', md: 'block' } }}
          container
          size={{ xs: 12, md: 6 }}
        >
          <List>
            {map(links, (item) => (
              <ListItemButton key={item.title} component="a" href={item.link}>
                <ListItemText primary={item.title} />
              </ListItemButton>
            ))}
          </List>
        </Grid>
        <Grid container size={{ xs: 12, md: 6 }} justifyContent="flex-end">
          <List>
            <ListItem>
              <ListItemText
                primary={`${t('name')} © ${new Date().getFullYear()}`}
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
};
